import { forwardRef } from 'react';

import { Input } from 'components/Form/Input';

const InputInsideCellComponent = ({ ...props }, ref: React.Ref<HTMLInputElement>) => (
  <Input inputWrapperClassName="h-full" wrapperClassName="size-full" {...props} ref={ref} />
);

export const InputInsideCell = forwardRef(InputInsideCellComponent);
